import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@Component({
    selector: 'app-calender',
    imports: [FormsModule, ReactiveFormsModule, CommonModule, BsDatepickerModule],
    templateUrl: './calender.component.html',
    styleUrl: './calender.component.scss'
})
export class CalenderComponent {
@Input() field: any = {};
  @Input() form!: FormGroup;

  @Output() messageEvent = new EventEmitter<string>();
  maxDate = new Date();
  endMinDate:  Date | undefined

  get isValid() { return this.form.controls[this.field.name].valid; }
  get isDirty() { return this.form.controls[this.field.name].dirty; }

  constructor() {

  }

  ngOnInit(): void {


  }
  bindStartDate(element:any) {
      console.log(element, 'sterr 1')
    this.messageEvent.emit(element);

  }
  datePicker() {
    console.log(this.form.value.fromDate,  this.field.minDate, 'fieee')
    if (this.field.name == 'dateto') {
      this.endMinDate =this.form.value.fromDate
    }
  }
}

